import { api } from 'app/config/apiConfig';

export const disableContractAutochargesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    disableAutocharges: builder.mutation<void, string>({
      query: (contractId) => ({
        url: `/contracts/${contractId}/autocharges/disable`,
        method: 'POST',
      }),
      invalidatesTags: ['Contracts', 'Contract details', 'Invoices'],
    }),
  }),
});

export const { useDisableAutochargesMutation } = disableContractAutochargesApi;
